export enum Seat {
    TWO = 2,
    FOUR = 4,
    FIVE = 5,
    SEVEN = 7,
    EIGHT = 8,
    NINE = 9,
}
